import { gql } from '@apollo/client';

export const CREATE_CRE_MUTATION = gql`
  mutation CreateCre($creCreateDto: CreCreateDto!) {
    createCre(creCreateDto: $creCreateDto) {
      id
      institutionName
      email
      createdDt
    }
  }
`;
